module.exports = __webpack_public_path__ + "static/img/CILER.79b755c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/CILER.jpg
// module id = SJ7A
// module chunks = 1